/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal } from "antd";
import QRCode from "qrcode.react";

const ModalQR = (props) => {

  const downloadQR = () => {
    const canvas = document.getElementById("QRcodeRender");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "QrCodeEVCharger.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <Modal open={props.openModal} centered closable={false}
      footer={
        <div className="w-full mb-4 space-x-4 flex justify-center">
          <Button
            className="w-38"
            type="primary"
            ghost
            key="cancel"
            shape="round"
            onClick={() => { props.onCancel() }}
          >
            Close
          </Button>
          <Button
            onClick={() => {
              downloadQR()
            }}
            className="w-38"
            key="save"
            type="primary"
            shape="round"
          >
            Download QR
          </Button>
        </div>
      }
      onCancel={() => props.onCancel()}>
      <div className="flex justify-center">
        <QRCode
          id="QRcodeRender"
          value={props.qrValue || ''}
          size={200}
          level={"L"}
          includeMargin={true}
        />
      </div>
    </Modal>
  )

}
export default ModalQR;